import { render, staticRenderFns } from "./UserPersonal.vue?vue&type=template&id=29bfca26&scoped=true&"
import script from "./UserPersonal.vue?vue&type=script&lang=js&"
export * from "./UserPersonal.vue?vue&type=script&lang=js&"
import style0 from "./UserPersonal.vue?vue&type=style&index=0&id=29bfca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfca26",
  null
  
)

export default component.exports